<template>
	<div id="page">
		<div class="page-content">
			<div class="fixed-top-box">
				<div class="page-title page-title-small">
					<h2 class="page-title-h2">
						<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
						گفتگوها
					</h2>
					<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
					<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
				</div>
				<div class="card header-card shape-rounded" data-card-height="100">
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
				</div>
				<div class="card card-style mb-2">
					<div class="p-3 d-flex">
						<button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
							<i class="fa fa-filter text-white"></i>
						</button>
						<div class="filter-row-scrollable">
							<div @click="lstFilter('Continued',1)" id="Continued" class="filterSelectItem filter-scrollable-box selected">جاری</div>
							<div @click="lstFilter('Archive',2)" id="Archive" class="filterSelectItem filter-scrollable-box ">بسته شده</div>
							<div @click="lstFilter('All',3)" id="All" class="filterSelectItem filter-scrollable-box ">همه</div>
						</div>
					</div>
				</div>
			</div>
			<span data-menu="menu-language" class="optionMenu"></span>
			<div class="main-content-box">
				<div v-if="ConversationList.length!=0">
					<div class="card card-style mb-2" v-for="item in ConversationList" :key="item.conversationId">
						<div class="list-group list-custom-small list-icon-0">
							<div class="list-group-div py-2 px-3" @click.prevent="openDetails(item.conversationId)">
								<div>
									<b class="font-13 text-dark">{{item.subject}}</b>
								</div>
								<div class="d-flex justify-content-between">
									<span class="text-muted text-left ltr d-inline-block">{{item.conversationDateTime}}</span>
									<span>
										<i class="fa fa-hashtag color-blue2-dark ml-0"></i>
										<span class="text-muted d-inline-block text-left ltr">{{item.conversationNo}}</span>
									</span>
								</div>
								<div class="d-flex justify-content-between">
									<div class="d-inline-flex align-items-center" style="width:90%">
										<!--اگر کاربر ارجاع کننده تصویر پروفایل نداشت-->
										<!--<i class="fa fa-user color-green2-light ml-0"></i>-->
										<!--تصویر پروفایل کاربر ثبت کننده کننده-->
										<img v-if="item.userImg!=null && item.userImg!=''" :src="item.userImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
										<i v-else class="fa fa-user-circle color-green2-light ml-2 font-30"></i>
										<span class="userTitle">{{item.userTitle}}</span>
									</div>
									<span class="text-left" @click.stop="showMenu(item)" style="width:10%"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
								</div>
							</div>
						</div>



					</div>
				</div>
				<div class="card card-style" v-if="ConversationList.length==0 && pageLoading==false">
					<div class="content">
						<div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
						<p class="text-center py-3">هیج موردی یافت نشد.</p>
					</div>
				</div>
				<div class="card card-style" v-if="pageLoading==false && NoMoreData==false && ConversationList.length>0 && ConversationList.length%10==0">
					<div class="content">
						<div class="d-flex justify-content-center w-100">
							<button class="btn btn-outline-info rounded-m" @click="GetNextPage">نمایش بیشتر</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoading==false" class="addBtn" id="addBtn" ref="addBtn">
				<router-link to="/ConversationCreate">
					<div class="icon icon-m rounded-m color-white bg-green2-light">
						<i class="fa fa-plus"></i>
					</div>
				</router-link>
			</div>
		</transition>

		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'ConversationEdit', params: { conversationId: conversationId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
					<button class="d-flex justify-content-between align-items-center bg-white p-0" @click.prevent="CloseConversation"><span class="d-inline-flex align-items-center"><i class="fa fa-times color-red1-light float-right font-14"></i>بستن</span><i class="fa fa-angle-left"></i></button>
					<button type="button" @click.prevent="deleteConversation" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>

		<div id="searchModal" class="modal fade" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header align-items-center">
						<h4 class="modal-title mt-0">جستجو</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body m-0">

						<div class="w-100 search-box rounded-m position-relative mb-3">
							<i class="fa fa-search pr-3"></i>
							<input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
						</div>

						<myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>
						<projects class="mb-3" @selectProject="selectProject"></projects>

						<calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>

						<button type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="page = 1;GetConversationList()">
							<i class="fa fa-search ml-2"></i>
							جستجو
						</button>
					</div>
				</div>
			</div>
		</div>

		<my-tour></my-tour>
	</div>

</template>
<script>
	import VueSimpleAlert from 'vue3-simple-alert';
	import calendarFilter from '../Components/CalendarFilter.vue';
	import MyTeamList from '../Components/MyTeamList.vue';
	import ProjectList from '../Components/ProjectList.vue';
	export default {
		components: {
			"calendar-filter": calendarFilter,
			"myTeamList": MyTeamList,
			"projects": ProjectList,
		},
		data() {
			return {
				pageLoading: false,
				NoMoreData: false,
				conversationId: 0,
				statuse: 1,
				page: 1,
				searchKey: "",
				date: null,
				userId: null,
				projectId: null,
				list: []
			}
		},
		computed: {
			ConversationList() {
				return this.list;
			},
		},
		methods: {
			CloseConversation(conid) {

				document.getElementsByClassName('menu-hider')[0].click();
				if (this.conversationId != 0) {
					VueSimpleAlert.confirm(
						"آیا مایل به بستن این مورد هستید؟",
						null,
						"question",
						{ confirmButtonText: "تایید", cancelButtonText: "انصراف" }
					).then(() => {
						this.pageLoading = true;
						this.$http
							.get("Conversation/Close"
								, {
									params: {
										id: this.conversationId

									}
								}
							)
							.then((data) => {
								this.pageLoading = false;
								var res = data.data;
								this.conversationId = 0;
								if (res != "1") {
									this.showErrorMessage(res);
								}
								else {
									this.showSuccessMessage('با موفقیت بسته شد.');
								}
							});

					});
				}
			},
			lstFilter(filterSelect, filterId) {
				this.statuse = filterId;
				var elements = document.getElementsByClassName('filterSelectItem');
				for (var i = 0; i < elements.length; i++) {
					elements[i].classList.remove('selected');
				}
				document.getElementById(filterSelect).classList.add('selected');
				this.page = 1;
				this.GetConversationList();
			},
			selectDate(d) {
				this.date = d;
			},
			selectUser(d) {
				this.userId = d;
			},
			selectProject(d) {
				this.projectId = d;
			},
			GetNextPage() {
				this.page = this.page + 1;
				this.GetConversationList();
			},
			deleteConversation() {
				document.getElementsByClassName('menu-hider')[0].click();
				if (this.conversationId != 0) {
					VueSimpleAlert.confirm(
						"آیا مایل به حذف این مورد هستید؟",
						null,
						"question",
						{ confirmButtonText: "تایید", cancelButtonText: "انصراف" }
					).then(() => {
						this.pageLoading = true;
						this.$http
							.get("Conversation/Delete"
								, {
									params: {
										id: this.conversationId

									}
								}
							)
							.then((data) => {
								this.pageLoading = false;
								var res = data.data;
								this.conversationId = 0;
								if (res == "1") {
									this.showSuccessMessage('اطلاعات با موفقیت حذف شد.');
									this.GetConversationList();
								} else {
									this.showErrorMessage(res);
								}
							});

					});
				}

			},
			GetConversationList() {
				this.pageLoading = true;
				if (this.page == 1)
					this.list = [];

				this.$http
					.get("Conversation/GetList"
						, {
							params: {
								searchKey: this.searchKey,
								date: this.date,
								userId: this.userId,
								status: this.statuse,
								page: this.page,
								projectId: this.projectId,

							}
						}
					)
					.then((data) => {
						var res = data.data;

						this.list = this.list.concat(data.data);
						if (this.list.length <= 0)
							this.NoMoreData = true;
						this.pageLoading = false;
					});
			},
			showMenu(t) {
				this.conversationId = t.conversationId;
				document.getElementsByClassName("optionMenu")[0].click();
			},
			openDetails(conversationId) {
				this.$router.push({ name: 'ConversationEdit', params: { conversationId: conversationId } });
				document.getElementsByClassName('menu-hider')[0].click();
			},
		},
		created() {
			this.GetConversationList();
		},
	}
</script>